import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const EssendonNorthPage = () => (
  <LocationTemplate suburbName="Essendon North" suburbSlug="essendon-north" />
);

export default EssendonNorthPage;
